import * as React from "react"

import { GlobalState } from "../../../store"
import { useAppSelector } from "../../../hooks"

import { isFullRow } from "../../fields/helper"
import { IField } from "../../fields"
import { Field } from "../../fields/components/Field"

export interface OwnProps {
    field: IField
}

type Props = OwnProps

export const GridField = ({ field }: Props): JSX.Element => {
    const { isLoading = false } = useAppSelector(
        (state: GlobalState) => state.fields,
    )
    const { type, position } = field

    // the section contains an array of fields that get rendered as a GridField
    if (type == "section") {
        return <Field field={field} isLoading={isLoading} />
    }

    return (
        <span
            className={`tw-px-6 ${
                isFullRow(type) ? "tw-flex tw-col-end-3" : ""
            }`}
            style={{
                gridColumn: position?.x,
                gridRow: position?.y,
                gridColumnEnd: undefined,
            }}
        >
            <Field field={field} isLoading={isLoading} />
        </span>
    )
}
